import styled from "styled-components";

export const CMSocialMedia = styled.div(({setRight, ...props}) => ({

  ...(setRight && {
    float: "right",
  }),
  
  "& svg": {
    width: "32px",
    height: "32px",
    cursor: "pointer",
    marginRight: props.theme.spacers["2"],
    fill: props.theme.palette.blue["600"],
  },

  [`@media (min-width: 2000px)`]: {
    "& svg": {
    width: "3.5vh !important",
    height: "3.5vh !important",
    },
  },

  [`@media ${props.theme.breakpoints.xs}`]: {
    display: "flex",
    justifyContent: "left",
    float: "none", 
    marginTop: "15px"
  },
  
}));
